module.exports = __webpack_public_path__ + "static/media/secure_organisation.5f86ebbb.png";